export default "__VITE_ASSET__c6334ecf__"